import { trpc } from '@klear/ui/lib/trpc'
import { useMutationWithToast, createToastConfig } from '@klear/ui/hooks/use-mutations-with-toast'

export function useEmailMutations() {
  const sendWelcomeEmailMutation = useMutationWithToast(
    trpc.email.sendWelcomeEmail.useMutation,
    createToastConfig('Welcome Email', 'send'),
    {
      invalidateQueries: []
    }
  )

  const sendWelcomeEmail = async (userId: number) => {
    const result = await sendWelcomeEmailMutation.mutateAsync({ userId })
    return result
  }

  return {
    sendWelcomeEmail,
    isSendingWelcomeEmail: sendWelcomeEmailMutation.isPending
  }
}
